import styled from 'styled-components';

export const NavContainer = styled.header`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
	background-color: white;
	box-sizing: border-box;
	position: relative;
	background-color: ${({ theme }) => theme.colors.bgSecondary};

	@media only screen and (max-width: 767px) {
		padding: 16px;
	}
`;
